var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.noPermission
    ? _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.showLog } },
        [_vm._v(_vm._s(_vm.$t("logText")))]
      )
    : _c(
        "el-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: _vm.permission,
              expression: "permission",
            },
          ],
          attrs: { type: "primary" },
          on: { click: _vm.showLog },
        },
        [_vm._v(" " + _vm._s(_vm.$t("logText")) + " ")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }